<template>
  <div class="altrama-extension">
    <div class="form-group">
      <h2>Work in progress demo</h2>
    </div>

    <div class="form-group">
      <input
        type="text"
        class="form-control"
        id="exampleInputText"
        v-model="text"
      />
      <label for="exampleInputText">Campo di tipo testuale</label>
    </div>
    <div class="form-group">
      <input type="email" class="form-control" id="exampleInputEmail1" />
      <label for="exampleInputEmail1">Campo di tipo email</label>
    </div>
    <div class="form-group">
      <input type="number" class="form-control" id="exampleInputNumber" />
      <label for="exampleInputNumber">Campo di tipo numerico</label>
    </div>
    <div class="form-group">
      <input type="tel" class="form-control" id="exampleInputTelephone" />
      <label for="exampleInputTelephone">Campo di tipo telefono</label>
    </div>
    <div class="form-group">
      <input
        type="time"
        class="form-control"
        id="exampleInputTime"
        min="9:00"
        max="18:00"
      />
      <label for="exampleInputTime">Campo di tipo ora</label>
    </div>

    <div class="form-group">
      <div class="bootstrap-select-wrapper">
        <label>Etichetta</label>
        <select title="Scegli una opzione" v-model="choose">
          <option value="Value 1">Opzione 1</option>
          <option value="Value 2">Opzione 2</option>
          <option value="Value 3">Opzione 3</option>
          <option value="Value 4">Opzione 4</option>
          <option value="Value 5">Opzione 5</option>
        </select>
      </div>
    </div>
  </div>
</template>
<script>
//var $ = window.$;
var $ = window.jQuery;
export default {
  components: {},
  computed: {
    baseUrl: function () {
      return window.location.origin;
    },
  },

  props: ["default_attribute"],

  created() {
    console.log("Created");
  },

  mounted() {
    this.c = 1;
  },

  updated() {
    $("select").selectpicker(); //per la multiselect
    this.$jQueryWrapSelect(); //singole select
  },

  data() {
    return {
      items: ["a", "b", "c", "d"],
      c: 0,
      choose: "Value 2",
      text: this.default_attribute,
    };
  },
  methods: {},
};
</script>


